// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Q5nL","content":"styles_content__3OESi","selectAll":"styles_selectAll__1qykf"};